import {
  Component ,Input  
} from '@angular/core'; 
import { CoreClass } from '@src/app/core/base/core.class';

@Component({
  selector: 'app-iconbox-one',
  templateUrl: './iconbox-one.component.html',
  styleUrls: ['./iconbox-one.component.scss'],
  standalone:false
})
export class IconboxOneComponent extends CoreClass {
  @Input() icon: string |  null = '';
  @Input() class: string |  null = '';
  @Input() heading: string |  null = '';
  @Input() description: string |  null = '';
  @Input() divStyle? : string | null = ''
  @Input() imgStyle? : string | null = ''

}
